import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { IRespPreRegister } from '../../models/ApplicationUser';

@Component({
  selector: 'app-data-registers',
  templateUrl: './data-registers.page.html',
  styleUrls: ['./data-registers.page.scss'],
})
export class DataRegistersPage implements OnInit {

  @Input() componentProps: IRespPreRegister = { Telefono: '', ID_Bodega: 0, NUD: 0 } as IRespPreRegister;

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  public onClick = (value: boolean) => this.modalCtrl.dismiss(value);

}
